import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tooltiptable',
  imports: [CommonModule],
  templateUrl: './tooltiptable.component.html',
  styleUrl: './tooltiptable.component.scss'
})
export class TooltiptableComponent {
@Input() tableData: { headers: string[], rows: any[][] } | null = null;
ngOnInit() {
  }

}
